
export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    imageSize: {
      type: String,
      default: 'xsmall',
    },
  },
  computed: {
    images() {
      let image = this.product?.Media?.Images?.product_medium;

      if (this.imageSize === 'xsmall') {
        image = this.product?.Media?.Images?.product_xsmall;
      }
      if (this.imageSize === 'small') {
        image = this.product?.Media?.Images?.product_small;
      }

      if (image) {
        return image;
      } else {
        return null;
      }
    },

    price() {
      return this.product?.Price;
    },

    hasPromtion() {
      if (this.price?.PromotionalPrice) return true;

      return false;
    },

    regularPrice() {
      return this.price?.RegularPrice;
    },
    promotionalPrice() {
      return this.price?.PromotionalPrice;
    },
    currencySign() {
      return this.$localisation.currencySign;
    },
    linkCategory() {
      try {
        const seo = this.product.SEO;
        if (seo) {
          const mainCategory = seo.MainCategory.find((item) => {
            return this.$i18n.locale === item.LanguageIsoCode;
          });
          if (!mainCategory) return 'product';
          return mainCategory.CategoryDescriptionFriendlyURL || 'product';
        }
      } catch (error) {}
      return 'product';
    },
    linkProduct() {
      try {
        const seo = this.product.SEO;
        if (seo) {
          const productSeo = seo.Product.find((item) => {
            return this.$i18n.locale === item.LanguageIsoCode;
          });
          if (!productSeo) return this.product.IdProduct;
          return (
            productSeo.ProductDescriptionFriendlyURL || this.product.IdProduct
          );
        }
      } catch (error) {}
      return this.product.IdProduct;
    },
    productUrl() {
      return this.localePath(`/${this.linkCategory}/${this.linkProduct}`);
    },
  },
  methods: {
    getSelectedOption(product) {
      if (product?.Variant) {
        const selectedProduct = product.Variant.find(
          (variant) => variant.Selected
        );
        if (selectedProduct?.Combination) {
          //   return selectedProduct
          //     ? selectedProduct?.Combination.IdProductAttribute
          //     : null;
          if (selectedProduct?.Combination?.Attributes) {
            const sizeAttribute = selectedProduct?.Combination?.Attributes.find(
              (attr) => attr.GroupName === 'Size'
            );
            return {
              label: sizeAttribute?.AttributeName,
              value: selectedProduct.Combination.IdProductAttribute,
            };
          }
        }
      }
      return {};
    },
  },
};
